import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=70ae2482&"
import script from "./Nav.vue?vue&type=script&lang=js&"
export * from "./Nav.vue?vue&type=script&lang=js&"
import style0 from "./Nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ae2482')) {
      api.createRecord('70ae2482', component.options)
    } else {
      api.reload('70ae2482', component.options)
    }
    module.hot.accept("./Nav.vue?vue&type=template&id=70ae2482&", function () {
      api.rerender('70ae2482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/summary/components/Nav.vue"
export default component.exports